export default __webpack_public_path__ + "static/media/PP_logo_yellow.118c834f.png";